import { matchHLATyping } from "./MatchScores";
import clinicalDataService from "../../../utils/clinicalDataService";

/**
 * Calculates HLA Match Score between a recipient and donor.
 * Supports pre-fetched clinical pair data to bypass network requests entirely.
 * When network fetching is required, routes through clinicalDataService for caching and deduplication.
 */
const HLAMatchScore = async (recipient, donor, providedClinicalData = null) => {
  try {
    let clinicalData = providedClinicalData;

    // 1. If not provided directly, fetch via deduplicating cache service
    if (!clinicalData?.recipient_clinical || !clinicalData?.donor_clinical) {
      clinicalData = await clinicalDataService.fetchClinicalPair(recipient, donor);
    }

    if (clinicalData?.recipient_clinical && clinicalData?.donor_clinical) {
      const result = matchHLATyping(
        clinicalData.recipient_clinical,
        clinicalData.donor_clinical
      );
      return result.matchPercentage;
    }

    return 0;
  } catch (err) {
    console.error("[HLAMatchScore] Calculation error:", err.message);
    return 0;
  }
};

export default HLAMatchScore;
